<template>
  <div class="theme">
    <div class="title">编辑专题</div>
    <el-card style="marginTop:10px;">
      <p class="title">编辑专题</p>
      <p class="mess">基础信息</p>

      <el-form :model="userForm"
               ref="userForm"
               :rules="rules"
               label-width="100px"
               style="marginTop:16px"
               class="userForm">
        <el-form-item label="专题标题："
                      prop="title">
          <el-input v-model="userForm.title"
                    placeholder="请输入笔记标题"></el-input>
        </el-form-item>

        <el-form-item label="主图："
                      prop="chief_img">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     list-type="picture-card"
                     :on-remove="handleChiefkRemove"
                     :file-list="userForm.chief_img"
                     :headers="uploadHeaders"
                     :on-success="handleUploadSuccess"
                     :before-upload="handleBeforeUpload"
                     :show-file-list="false">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar">
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="背景图："
                      prop="background_imgs">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     list-type="picture-card"
                     :on-remove="handleBcakRemove"
                     :file-list="userForm.background_imgs"
                     :headers="uploadHeaders"
                     :on-success="handleBackUploadSuccess"
                     :before-upload="handleBackBeforeUpload"
                     :on-exceed="handleExceed"
                     drag
                     :limit="limit"
                     :show-file-list="true">

            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>

        <el-form-item label="副图："
                      prop="assit_img">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     :limit="assitLimit"
                     list-type="picture-card"
                     :on-remove="handleAssitRemove"
                     :file-list="userForm.assit_img"
                     :headers="uploadHeaders"
                     :on-success="handleAssitUploadSuccess"
                     drag
                     :show-file-list="true"
                     :on-exceed="handleAssitExceed">

            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="参数一："
                      prop="extend_param_one">
          <el-input v-model="userForm.extend_param_one"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="参数二："
                      prop="extend_param_two">
          <el-input v-model="userForm.extend_param_two"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="参数三："
                      prop="extend_param_three">
          <el-input v-model="userForm.extend_param_three"
                    placeholder="参数一"></el-input>
        </el-form-item>
        <el-form-item label="有效期："
                      prop="datetime">
          <el-date-picker :default-time="['00:00:00', '23:59:59']"
                          format="yyyy-MM-dd HH:mm"
                          class="datetime"
                          v-model="userForm.datetime"
                          type="datetimerange"
                          range-separator="至"
                          value-format="timestamp"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="院校："
                      prop="page_college_codes">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in colleges"
                    closable
                    :disable-transitions="false"
                    @close="handleCollegeRemove(item)">
              {{ `${item.name}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleCollegeChoose(1)">选择院校</el-button>
          </div>
        </el-form-item>
        <el-form-item label="专业："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in majors"
                    closable
                    :disable-transitions="false"
                    @close="handleMajorRemove(item)">
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleMajorChoose(1)">选择专业</el-button>
          </div>
        </el-form-item>

        <el-form-item label="科目："
                      prop="majors">
          <div class="tag-wrap">
            <el-tag class="subject-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in subjects"
                    closable
                    :disable-transitions="false"
                    @close="handleSubjectRemove(item)">
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button type="text"
                       @click="handleSubjectChoose(1)">选择科目</el-button>
          </div>
        </el-form-item>

        <el-form-item label="详情图："
                      prop="detail_imgs">
          <el-upload class="avatar-uploader"
                     :action="imgUploadUrl"
                     :limit="detailLimit"
                     list-type="picture-card"
                     :file-list="userForm.detail_imgs"
                     :headers="uploadHeaders"
                     :on-remove="handleDetailRemove"
                     :on-success="handleDetailUploadSuccess"
                     drag
                     :show-file-list="true"
                     :on-exceed="handleDetailExceed">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="选择商品："
                      prop="ref_id">
          <div class="tag-wrap">
            <el-tag class="user-item"
                    size="medium"
                    :key="item.id"
                    v-for="item in products"
                    closable
                    :disable-transitions="false"
                    @close="handleProductsRemove(item)"
                    type="success">
              {{item.name}}
            </el-tag>
            <el-button type="text"
                       @click="handleGoodChoose">选择商品</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle">取消</div>
        <div class="confirm"
             @click="submit()">确定</div>
      </div>
    </el-card>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"
                   :chooseType="chooseType"></CollegeChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"
                 :chooseType="chooseMajorType"></MajorChoose>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"
                   :chooseType="chooseSubjectType"></SubjectChoose>
    <GoodsTabsChoose :visible="goodsChooseDialog"
                     type="multiple"
                     @close="goodsChooseDialog = false"
                     @submit="saveGoods"
                     :goods="products" />
  </div>
</template>
<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import {
  themePageCreate,
  themePageDetail,
  themePagePut,
  themeType,
  categoryDetail,
} from '@/api/senior'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import GoodsTabsChoose from '@/components/dialog/product/GoodsTabsChoose'
export default {
  components: { CollegeChoose, MajorChoose, SubjectChoose, GoodsTabsChoose },
  data() {
    return {
      goodsChooseDialog: false,
      chooseType: true,
      chooseMajorType: true,
      chooseSubjectType: true,
      type: 1,
      dataForm: {},
      chooseVisible: false,
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      limit: 3,
      assitLimit: 1,
      detailLimit: 9,
      userForm: {
        chief_img: [],
        background_imgs: [],
        assit_img: [],
        detail_imgs: [],
        extend_param_one: '',
        extend_param_two: '',
        extend_param_three: '',
        datetime: [],
      },
      chooseSenior: [
        ////{
        //category_name: '',
        //filterItem: [],
        //chooseItem: [],
        //senior_inner_remark: '',
        //},
      ],
      imageUrl: '',
      assitUrl: '',
      subjects: [],
      majors: [],
      colleges: [],
      collegesType: [],
      majorsType: [],
      subjectsType: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        title: [{ required: true, message: '请输入笔记专题', trigger: 'blur' }],
        // datetime: [
        //   {
        //     required: true,
        //     message: '请选择有效期',
        //     trigger: 'change',
        //     validator: (rule, value, callback) => {
        //       if (!this.userForm.datetime) {
        //         return callback(new Error(rule.message))
        //       } else {
        //         callback()
        //       }
        //     },
        //   },
        // ],
        chief_img: [
          {
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.chief_img.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        background_imgs: [
          {
            required: true,
            message: '请上传背景图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.background_imgs.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        detail_imgs: [
          {
            required: true,
            message: '请上传详情图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.userForm.detail_imgs.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
      },
      tutorList: [
        {
          id: 101,
          value: '政治',
          isFlag: false,
        },
        {
          id: 102,
          value: '英语一',
          isFlag: false,
        },
        {
          id: 103,
          value: '英语二',
          isFlag: false,
        },
        {
          id: 104,
          value: '数学一',
          isFlag: false,
        },
        {
          id: 105,
          value: '数学二',
          isFlag: false,
        },
        {
          id: 106,
          value: '数学三',
          isFlag: false,
        },
        {
          id: 107,
          value: '英语作文批改',
          isFlag: false,
        },
        {
          id: 108,
          value: '199管理类综合',
          isFlag: false,
        },
        {
          id: 109,
          value: '408计算机综合',
          isFlag: false,
        },

        {
          id: 201,
          value: '复试邮件简历',
          isFlag: false,
        },
        {
          id: 202,
          value: '中英文自我介绍',
          isFlag: false,
        },
        {
          id: 203,
          value: '复试口语',
          isFlag: false,
        },
        {
          id: 204,
          value: '综合面试',
          isFlag: false,
        },
        {
          id: 205,
          value: '调剂指导',
          isFlag: false,
        },
        {
          id: 301,
          value: '高等数学',
          isFlag: false,
        },
        {
          id: 302,
          value: '线性代数',
          isFlag: false,
        },
        {
          id: 303,
          value: '概率论与数理统计',
          isFlag: false,
        },
        {
          id: 304,
          value: '大学物理',
          isFlag: false,
        },
        {
          id: 305,
          value: '材料力学',
          isFlag: false,
        },
        {
          id: 306,
          value: '数字电路与模拟电路',
          isFlag: false,
        },
        {
          id: 307,
          value: '理论力学',
          isFlag: false,
        },
        {
          id: 308,
          value: '电工学',
          isFlag: false,
        },
        {
          id: 309,
          value: '运筹学',
          isFlag: false,
        },
        {
          id: 310,
          value: '机械原理',
          isFlag: false,
        },
        {
          id: 311,
          value: '结构力学',
          isFlag: false,
        },
        {
          id: 312,
          value: '自动控制原理',
          isFlag: false,
        },
        {
          id: 313,
          value: '电路',
          isFlag: false,
        },
        {
          id: 401,
          value: '英语四六级',
          isFlag: false,
        },
        {
          id: 402,
          value: '雅思',
          isFlag: false,
        },
        {
          id: 403,
          value: '托福',
          isFlag: false,
        },
        {
          id: 404,
          value: 'GRE',
          isFlag: false,
        },
        {
          id: 405,
          value: '英语专业四级',
          isFlag: false,
        },
        {
          id: 406,
          value: '英语专业八级',
          isFlag: false,
        },
        {
          id: 407,
          value: '计算机二级',
          isFlag: false,
        },
        {
          id: 501,
          value: '教师资格证',
          isFlag: false,
        },
        {
          id: 502,
          value: '法律职业资格（法考）',
          isFlag: false,
        },
        {
          id: 503,
          value: '证券/基金/银行从业资格',
          isFlag: false,
        },
        {
          id: 504,
          value: '初级会计职称',
          isFlag: false,
        },
        {
          id: 505,
          value: '注册会计师（CPA）',
          isFlag: false,
        },
        {
          id: 506,
          value: '导游资格证',
          isFlag: false,
        },
      ],
      extra_tutoring_types: '',
      activeIndex: 0,
      extraCollege: [],
      products: [],
    }
  },
  created() {
    this.$store.dispatch('getAllColleges')

    this.getDetail()
  },
  methods: {
    handleGoodChoose() {
      if (this.products.length == 1) {
        this.$message.error('最多选择一个商品')
        return
      } else {
        this.goodsChooseDialog = true
      }
    },
    saveGoods(val) {
      this.products = val.goods
    },
    handleProductsRemove(item) {
      this.products = this.products.filter((v) => v.id !== item.id)
    },
    handleBcakRemove(file, fileList) {
      this.userForm.background_imgs = fileList
    },
    handleAssitRemove(file, fileList) {
      this.userForm.assit_img = fileList
    },
    handleDetailRemove(file, fileList) {
      this.userForm.detail_imgs = fileList
    },
    handleChiefkRemove(file, fileList) {
      this.userForm.chief_img = fileList
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    chooseTutur() {},
    handleClose() {
      this.chooseVisible = false
      this.extra_tutoring_types = ''
      this.collegesType = []
      this.majorsType = []
      this.subjectsType = []
    },
    //  获取主题页详情
    getDetail() {
      themePageDetail({
        id: this.$route.params.editId,
      }).then((res) => {
        this.$set(this.userForm, 'title', res.title)
        // 主图
        this.imageUrl = res.chief_img
        res.chief_img.split(',').map((item) => {
          this.userForm.chief_img.push({
            url: item,
          })
        })
        // 背景图
        if (res.background_imgs.split(',').length > 0) {
          res.background_imgs.split(',').map((item) => {
            this.userForm.background_imgs.push({
              url: item,
            })
          })
        }
        // 背景图
        if (res.assist_img.split(',').length > 0) {
          res.assist_img.split(',').map((item) => {
            this.userForm.assit_img.push({
              url: item,
            })
          })
        }
        // 参数
        this.userForm.extend_param_one = res.extend_param_one
        this.userForm.extend_param_two = res.extend_param_two
        this.userForm.extend_param_three = res.extend_param_three
        // 有效期
        this.userForm.datetime = [res.start_time, res.end_time]
        //回显院校和专业
        if (res.page_college_codes != '') {
          res.page_college_codes.split(',').map((t, index) => {
            res.page_college_names.split(',').map((p, y) => {
              if (index == y) {
                this.colleges.push({
                  code: t,
                  name: p,
                })
              }
            })
          })
        }

        if (res.page_major_codes != '') {
          res.page_major_codes.split(',').map((t, index) => {
            res.page_major_names.split(',').map((p, y) => {
              if (index == y) {
                this.majors.push({
                  code: t,
                  name: p,
                })
              }
            })
          })
        }
        if (res.page_subject_codes != '') {
          res.page_subject_codes.split(',').map((t, index) => {
            res.page_subject_names.split(',').map((p, y) => {
              if (index == y) {
                this.subjects.push({
                  code: t,
                  name: p,
                })
              }
            })
          })
        }
        // 详情图
        if (res.detail_imgs != '') {
          // this.userForm.detail_imgs=
          res.detail_imgs.split(',').map((item) => {
            this.userForm.detail_imgs.push({
              url: item,
            })
          })
        }
        if (res.bring_product_list.length > 0) {
          this.products = res.bring_product_list
        }
      })
    },

    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleMajorChoose(types) {
      this.type = types
      this.majorChooseDialog = true
    },
    handleSubjectChoose(types) {
      this.type = types

      this.subjectChooseDialog = true
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeTypeRemove(item) {
      this.collegesType = this.collegesType.filter((v) => v.id !== item.id)
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorTypeRemove(item) {
      this.majorsType = this.majorsType.filter((v) => v.id !== item.id)
    },
    handleSubjecTypeRemove(item) {
      this.subjectsType = this.subjectsType.filter((v) => v.id !== item.id)
    },
    handleAddType() {
      this.chooseSenior.push({
        category_name: '',
        filterItem: [],
        senior_inner_remark: '',
        chooseItem: [],
      })
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.chief_img.push({ url: res.data.url, name: '' })
        this.imageUrl = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload() {},
    handleBackUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.background_imgs.push({ url: res.data.url, name: '' })
      } else {
        this.$message.error(res.error)
      }
    },
    handleAssitUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.assit_img.push({ url: res.data.url, name: '' })
      } else {
        this.$message.error(res.error)
      }
    },
    handleDetailUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.userForm.detail_imgs.push({ url: res.data.url, name: '' })
      } else {
        this.$message.error(res.error)
      }
    },
    handleBackBeforeUpload(file) {},
    // 超出上传数量的处理
    handleExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.limit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    handleDetailExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.detailLimit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    handleAssitExceed(files, fileList) {
      // 提示用户超出限制
      this.$message.error(`最多只能上传${this.assitLimit}张图片`)
      // 可选：清空超出的文件（防止用户重复选择）
      return false
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    collegeChange(e) {
      this.userForm.page_college_names = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
    },
    submit() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          let data = {
            title: this.userForm.title,
            chief_img: this.imageUrl,
            background_imgs: this.userForm.background_imgs,
          }
          // 背景图片
          let backImg = []
          this.userForm.background_imgs.map((item) => {
            backImg.push(item.url)
          })
          data.background_imgs = backImg.join(',')
          //副图
          let assitImg = []
          if (this.userForm.assit_img.length > 0) {
            this.userForm.assit_img.map((item) => {
              assitImg.push(item.url)
            })
            data.assist_img = assitImg.join(',')
          }
          data.extend_param_one = this.userForm.extend_param_one
          data.extend_param_two = this.userForm.extend_param_two
          data.extend_param_three = this.userForm.extend_param_three
          // 有效期
          data.start_time = this.userForm.datetime[0]
          data.end_time = this.userForm.datetime[1]
          // 院校科目专业
          let collegeName = []
          let collegeCode = []
          let majorName = []
          let majorCode = []
          let subjectName = []
          let subjectCode = []
          if (this.colleges.length > 0) {
            this.colleges.map((item) => {
              collegeName.push(item.name)
              collegeCode.push(item.code)
            })
            data.page_college_codes = collegeCode.join(',')
            data.page_college_names = collegeName.join(',')
          }
          if (this.majors.length > 0) {
            this.majors.map((item) => {
              majorName.push(item.name)
              majorCode.push(item.code)
            })
            data.page_major_codes = majorCode.join(',')
            data.page_major_names = majorName.join(',')
          }
          if (this.subjects.length > 0) {
            this.subjects.map((item) => {
              subjectName.push(item.name)
              subjectCode.push(item.code)
            })
            data.page_subject_codes = subjectCode.join(',')
            data.page_subject_names = subjectName.join(',')
          }
          // 详情图
          let detailImg = []
          if (this.userForm.detail_imgs.length > 0) {
            this.userForm.detail_imgs.map((item) => {
              detailImg.push(item.url)
            })
          }
          data.detail_imgs = detailImg.join(',')

          data.id = this.$route.params.editId
          if (this.products.length > 0) {
            data.bring_product_ids = this.products[0].id
          } else {
            data.bring_product_ids = ''
          }

          themePagePut(data).then((res) => {
            this.$router.push(`/senior/topicMangement`)
            this.$message.success('操作成功')
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-upload-dragger {
  width: 90px;
  height: 90px;
}
::v-deep .el-upload--picture-card {
  width: 90px;
  height: 90px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}
.theme {
  padding: 16px;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #303133;
  }
  .mess {
    margin-top: 14px;
    padding-left: 17px;
    width: 100%;
    height: 51px;
    font-weight: 700;
    line-height: 51px;
    background: #f5f5f5;
    border-radius: 0px 0px 0px 0px;
  }
  .avatar {
    width: 87px;
    height: 87px;
  }
  .chooseSenior {
    padding: 14px;
    width: 100%;
    min-height: 220px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    .typeName {
      font-size: 14px;
      color: #606266;
      padding: 14px;
      display: flex;
      align-items: center;
      height: 51px;
      background: #f5f5f5;
    }
  }
  .tag-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .subject-item,
  .teacher-item {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .addType {
    margin-top: 16px;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #409eff;
    width: 78px;
    height: 32px;
    line-height: 32px;
    background: rgba(64, 158, 255, 0.2);
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #409eff;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    .cancle {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #909399;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      margin-right: 16px;
    }
    .confirm {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      width: 56px;
      height: 36px;
      line-height: 36px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>